import type { BaseUniDriver } from 'ricos-types/testkit';
import { dataHook } from 'wix-rich-content-common';

import {
  COLLAPSIBLE_LIST_ITEM,
  COLLAPSIBLE_LIST_ITEM_BODY,
  COLLAPSIBLE_LIST_ITEM_TITLE,
  EXPAND_BUTTON,
} from '../dataHooks';

export type CollapsibleListItemUniDriver = {
  atIndex: (index: number) => {
    exists: () => Promise<boolean>;
    toggleCollapse: () => Promise<void>;
    titleExists: () => Promise<boolean>;
    clickTitle: () => Promise<void>;
    getTitleText: (stringLine: number) => Promise<string>;
    bodyExists: () => Promise<boolean>;
    clickBody: () => Promise<void>;
    getNativeElement: () => Promise<Element>;
  };
};

export const createCollapsibleListItemUniDriver: BaseUniDriver<
  CollapsibleListItemUniDriver
> = getBase => {
  const getListItem = (index: number) => getBase().$$(dataHook(COLLAPSIBLE_LIST_ITEM)).get(index);

  return {
    atIndex: index => {
      return {
        exists: async () => {
          const listItem = getListItem(index);
          return listItem.exists();
        },
        toggleCollapse: async () => {
          const listItem = getListItem(index);
          const toggleBtn = listItem.$(dataHook(EXPAND_BUTTON));
          await toggleBtn.click();
        },
        titleExists: async () => {
          const listItem = await getListItem(index);
          const listItemTitle = await listItem.$(dataHook(COLLAPSIBLE_LIST_ITEM_TITLE));
          return listItemTitle.exists();
        },
        clickTitle: async () => {
          const listItem = await getListItem(index);
          const listItemTitle = await listItem.$(dataHook(COLLAPSIBLE_LIST_ITEM_TITLE));
          await listItemTitle.click();
        },
        getTitleText: async stringLine => {
          const listItem = await getListItem(index);
          const listItemTitleText = await listItem.getAll(
            `${dataHook(COLLAPSIBLE_LIST_ITEM_TITLE)} span`
          );
          return listItemTitleText.at(stringLine).text();
        },
        bodyExists: async () => {
          const listItem = getListItem(index);
          const listItemBody = listItem.$(dataHook(COLLAPSIBLE_LIST_ITEM_BODY));
          return listItemBody.exists();
        },
        clickBody: async () => {
          const listItem = getListItem(index);
          const listItemBody = await listItem.get(dataHook(COLLAPSIBLE_LIST_ITEM_BODY));
          return listItemBody.click();
        },
        getNativeElement: async () => {
          const listItem = getListItem(index);
          return listItem.getNative();
        },
      };
    },
  };
};
